<app-lista-dados
  [upTitulo]="'Usuários do Veículo'"
  [upIcone]="'group'"
  [upDados]="dados"
  [upColunas]="colunas"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="true"
  [upFiltroRapido]="filtrarLinha"
  [upHabilitaEditarLinha]="true"
  [upCarregando]="!!subscription"
  [upAcoesLinha]="acoesLinha"
  [upHabilitaBotaoIncluir]="!!isProprietario"
  [upHabilitaBotaoEditar]="false"
  [upPermitirEdicaoLinhaExistente]="false"
  [upVisivelBotaoExcluir]="podeExcluir"
  (ueAcaoLinha)="onTrocarProprietario()"
  (ueIniciarEdicaoLinha)="onIniciarEdicaoLinha($event)"
  (ueSalvarLinha)="onSalvarLinha($event)"
  (ueBotaoExcluir)="onDelete($event)">
</app-lista-dados>
